<template>
    <form @submit.prevent="handleSubmit(item)" novalidate ref="form">
        <div>

            <div v-if="!amountFromTransfer" :class="{ 'form-group': true, 'has-error': (errors && errors.settlementType) }">
                <label for="_deductionTypes" class="control-label">Type rozliczenia</label>
                <dropdown-search
                        :elements="settlementTypesToShow"
                        v-model="item.settlementType"
                        emptyValue="Wybierz typ"
                        id="_deductionTypes"
                        nameField="name"
                        valueField="value"/>
                <span v-if="errors && errors.settlementType" class="help-block"
                      id="_deductionTypes_helpBlock">{{ errors.settlementType}}</span>
            </div>
            <div :class="{ 'form-group': true, 'has-error': (errors && errors.deductionType) }">
                <label for="_deductionTypes" class="control-label">{{deductionTyleLabel}}</label>
                <dropdown-search
                        :elements="deductionTypesToShow"
                        v-model="selectedDeductionType"
                        emptyValue="Wybierz typ"
                        id="_deductionTypes"
                        nameField="name"/>
                <span v-if="errors && errors.deductionType" class="help-block"
                      id="_deductionTypes_helpBlock">{{ errors.deductionType}}</span>
            </div>
            <alert-loading v-if="invoiceToDeductionLoading"></alert-loading>
            <div v-if="selectedDeductionType && selectedDeductionType.systemType == 'invoice' && invoiceToDeductionLoading == false"
                 :class="{ 'form-group': true, 'has-error': (errors && errors.factoredInvoice) }">
                <label for="_factoredInvoice" class="control-label">Faktura</label>
                <dropdown-search
                        :elements="invoiceToDeduction"
                        v-model="selectedInvoiceToDeduction"
                        emptyValue="Wybierz fakturę"
                        :isSearch="true"
                        id="_factoredInvoice"
                        nameField="fullName"/>
                <span v-if="errors && errors.factoredInvoice"
                      class="help-block"
                      id="_factoredInvoice_helpBlock"
                >{{ errors.factoredInvoice}}</span>
            </div>
            <alert-loading v-if="invoiceToRefundLoading"></alert-loading>
            <div v-if="selectedDeductionType && selectedDeductionType.systemType == 'refund' && invoiceToRefundLoading == false"
                 :class="{ 'form-group': true, 'has-error': (errors && errors.refundFactoredInvoice) }">
                <label for="_refundFactoredInvoice" class="control-label">Faktura</label>
                <dropdown-search
                        :elements="invoiceToRefund"
                        v-model="selectedInvoiceToRefund"
                        emptyValue="Wybierz fakturę"
                        :isSearch="true"
                        id="_refundFactoredInvoice"
                        nameField="fullName"/>
                <span v-if="errors && errors.refundFactoredInvoice"
                      class="help-block"
                      id="_refundFactoredInvoice_helpBlock"
                >{{ errors.refundFactoredInvoice}}</span>
            </div>
            <div v-if="selectedDeductionType && selectedDeductionType.systemType == 'transfer'"
                 :class="{ 'form-group': true, 'has-error': (errors && errors.transferType) }">
                <label for="_transferTypes" class="control-label">Typ przelewu</label>
                <dropdown-search
                        :elements="transferTypes"
                        v-model="selectedTransferType"
                        emptyValue="Wybierz przelew"
                        id="_transferTypes"
                        nameField="name"/>
                <span v-if="errors && errors.transferType" class="help-block"
                      id="_transferTypes_helpBlock">{{ errors.transferType}}</span>
            </div>
            <div :class="{ 'form-group': true, 'has-error': (errors && errors.deductionDate) }">
                <label for="_deductionDate" class="control-label">Data</label>
                <el-date-picker
                        type="date"
                        v-model="item.deductionDate"
                        placeholder="Data">
                </el-date-picker>
                <span v-if="errors && errors.deductionDate" class="help-block"
                      id="_data_helpBlock">{{ errors.deductionDate }}</span>
            </div>
            <div :class="{ 'form-group': true, 'has-error': (errors && errors.amount) }">
                <label for="_amount" class="control-label">Kwota</label>
                <b-input-group :right="currencyName">
                    <b-form-input type="number" id="_amount" v-model="item.amount"></b-form-input>
                </b-input-group>
                <span v-if="errors && errors.amount" class="help-block" id="_amount_helpBlock">{{ errors.amount
                    }}</span>
            </div>
            <div :class="{ 'form-group': true, 'has-error': (errors && errors.comments) }">
                <label for="_comments" class="control-label">Uwagi</label>
                <input type="text" placeholder="" id="_comments" class="form-control full-width"
                       v-model="item.comments"/>
                <span v-if="errors && errors.comments" class="help-block" id="_comments_helpBlock">{{ errors.comments
                    }}</span>
            </div>
        </div>
    </form>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  export default {
    props: {
      handleSubmit: {
        type: Function,
        required: true,
      },
      values: {
        type: Object,
        required: true
      },
      currencyName: {
        type: String,
        required: true
      },
      errors: {
        type: Object
      },
      initialValues: {
        type: Object
      },
      amountFromTransfer: {
        type: Boolean,
        default: false
      },
      typeSelection: {
        type: String,
        default: 'advance-deduction'
      }
    },
    created(){
      this.setupFormData();
    },
    data: function () {
      return {
        selectedDeductionType: null,
        selectedTransferType: null,
        selectedInvoiceToDeduction: null,
        selectedInvoiceToRefund: null,
        initialValueOfFactoredInvoice: null,
        initialValueOfRefundFactoredInvoice: null,
      }
    },
    computed: {
      deductionTyleLabel(){
        return this.typeSelection == 'advance-deduction' ? 'Typ potrącenia' : 'Typ zwrotu';
      },
      item: function () {
        return this.initialValues ? this.initialValues : Object.keys(this.values).length > 0 ? this.values : {}
      },
      deductionTypesToShow: function () {
        if (this.typeSelection == 'advance-deduction') {
          return this.deductionTypes.filter((data) => {
            return data.systemType == 'other' || data.systemType == 'invoice' || data.systemType == 'transfer' || data.systemType == 'advance'
          })
        } else {
          return this.deductionTypes.filter((data) => {
            return data.systemType == 'refund' || data.systemType == 'refund_other'
          })
        }
      },
      settlementTypesToShow: function () {
        if(this.amountFromTransfer){
          return [{name: 'Rozliczenie', value:'settlement'}]
        }

        return [
          {name: 'Wstępne', value:'initial_settlement'},
          {name: 'Całkowite', value:'final_settlement'}
        ]
      },
      ...mapGetters({
        deductionTypes: 'config/config/deductionTypes',
        transferTypes: 'config/config/transferTypes',
        retrieved: 'agreement/update/retrieved',
        invoiceToDeduction: 'agreement/invoiceToDeduction/items',
        invoiceToDeductionLoading: 'agreement/invoiceToDeduction/loading',
        invoiceToRefund: 'agreement/invoiceToRefund/items',
        invoiceToRefundLoading: 'agreement/invoiceToRefund/loading',
      })
    },
    methods: {
      resetFormData (){
        this.selectedDeductionType = null
        this.selectedTransferType = null
        this.selectedInvoiceToDeduction = null
        this.selectedInvoiceToRefund = null
        this.initialValueOfFactoredInvoice = null
        this.initialValueOfRefundFactoredInvoice = null
      },
      setupFormData () {
        if (this.values) {
          if (this.values.deductionType) {
            this.selectedDeductionType = this.deductionTypes.find((data) => {
              return data['@id'] == this.values.deductionType
            })
          } else {
            this.selectedDeductionType = null
          }
          if (this.values.transferType) {
            this.selectedTransferType = this.transferTypes.find((data) => {
              return data['@id'] == this.values.transferType
            })
          } else {
            this.selectedTransferType = null
          }
          if (this.values.factoredInvoice) {
            this.initialValueOfFactoredInvoice = this.values.factoredInvoice
          } else {
            this.factoredInvoice = null
            this.initialValueOfFactoredInvoice = null
          }
          if (this.values.refundFactoredInvoice) {
            this.initialValueOfRefundFactoredInvoice = this.values.refundFactoredInvoice
          } else {
            this.refundFactoredInvoice = null
            this.initialValueOfRefundFactoredInvoice = null
          }
        }
      },
      sendForm () {
        this.handleSubmit(this.item)
      },
      ...mapActions({
        getInvoiceToDeduction: 'agreement/invoiceToDeduction/getItems',
        getInvoiceToRefund: 'agreement/invoiceToRefund/getItems'
      })
    },
    watch: {
      selectedDeductionType: function (data) {
        if(data) {
          this.item.deductionType = data['@id']
          if(data.systemType != 'transfer'){
            this.item.transferType = undefined
          }
          if(data.systemType != 'invoice'){
            this.item.factoredInvoice = undefined
          }
          if(data.systemType != 'refund'){
            this.item.refundFactoredInvoice = undefined
          }
        }
      },
      selectedTransferType: function (data) {
        if(data) {
          this.item.transferType = data['@id']
          if (data.amount > 0 && this.amountFromTransfer) {
            this.item.amount = data.amount
          }
        }
      },
      selectedInvoiceToDeduction: function (data) {
        if(data) {
          this.item.factoredInvoice = data['@id']
          if (data.leftToPaid > 0) {
            this.item.amount = data.leftToPaid
          }
        }
      },
      selectedInvoiceToRefund: function (data) {
        if(data) {
          this.item.refundFactoredInvoice = data['@id']
          if (data.amount) {
            this.item.amount = data.amount
          }
        }
      },
      'selectedDeductionType.systemType': function (data) {
        if (data == 'invoice' && this.retrieved) {
          this.getInvoiceToDeduction(this.retrieved)
        }
        if (data == 'refund' && this.retrieved) {
          this.getInvoiceToRefund(this.retrieved)
        }
      },
      'invoiceToDeductionLoading': function (data) {
        if (data == false && this.initialValueOfFactoredInvoice) {
          this.selectedInvoiceToDeduction = this.invoiceToDeduction.find((data) => {
            return data['@id'] == this.initialValueOfFactoredInvoice
          })
          this.initialValueOfFactoredInvoice = null
        }
      },
      'invoiceToRefundLoading': function (data) {
        if (data == false && this.initialValueOfFactoredInvoice) {
          this.selectedInvoiceToRefund = this.invoiceToRefund.find((data) => {
            return data['@id'] == this.initialValueOfFactoredInvoice
          })
          this.initialValueOfFactoredInvoice = null
        }
      },
    }
  }
</script>



// WEBPACK FOOTER //
// FormDeduction.vue?658463a4